export default String.raw`
.mainBanner {
    padding: 0 5%;

    &__slide {
        padding: 1px;

        &-mobile {
            display: block;
        }

        &-container {
            left: 0;

            &-box {
                padding: 12px;
                max-width: 100%;
                width: 100%;
                height: 100%;

                h1 {
                    @include h3-headline;
                    margin-bottom: 4px;
                    width: 100%;
                }
    
                h3 {
                    @include body-1-medium;
                    margin-bottom: 0;
                    width: 100%;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
    
                a {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    border-radius: 12px;
                    outline-offset: -2px !important;
                }
    
                .primary-action-button {
                    display: none;
                }
            }
        }

        &-placeholder {
            &::after {
                content: 'Mobile';
            }
        }
    }

    &__prev, &__next {
        visibility: hidden;
    }
}

.products-page {
    .mainBanner {
        margin-bottom: 15px;
    }
}
`